export type VesselEvaluationTableValue = string | number | boolean | null;

// Mirrors every field projected by the Power BI pivot table.
// Nullable values preserve blank Snowflake cells instead of inventing display defaults in the data layer.
export interface VesselEvaluationVessel {
  vesselName: string;
  design: string | null;
  vesselType: string | null;
  imo: string;
  status: string | null;
  deliveryDate: string | null;
  minRedeliveryDate: string | null;
  maxRedeliveryDate: string | null;
  contractType: string | null;
  dwt: number | null;
  buildDate: string | null;
  yard: string | null;
  engineType: string | null;
  mcr: number | null;
  eplMcrLimit: number | null;
  scrubber: boolean | null;
  esd: string | null;
  ladenDraftCorrection: number | null;
  ballastDraftCorrection: number | null;
  refAe: number | null;
  cleanHullSpeedBallastEco: number | null;
  consBallastEco: number | null;
  currentSpeedBallastEco: number | null;
  cleanHullSpeedBallastFull: number | null;
  consBallastFull: number | null;
  currentSpeedBallastFull: number | null;
  cleanHullSpeedLadenEco: number | null;
  consLadenEco: number | null;
  currentSpeedLadenEco: number | null;
  cleanHullSpeedLadenFull: number | null;
  consLadenFull: number | null;
  currentSpeedLadenFull: number | null;
  comment: string | null;
  currentAt115Knt: number | null;
  cpAt115Knt: number | null;
  cleanAt115Knt: number | null;
  currentAt125Knt: number | null;
  cpAt125Knt: number | null;
  cleanAt125Knt: number | null;
  evaluatedVps: string | null;
  cpBallastEcoSpeedCons: string | null;
  cpBallastFullSpeedCons: string | null;
  cpLadenEcoSpeedCons: string | null;
  cpLadenFullSpeedCons: string | null;
  paintVendor: string | null;
  lastDryDock: string | null;
  antifoulingAppliedDate: string | null;
  fb: string | null;
  vs: string | null;
  bt: string | null;
  propellerCoating: string | null;
  paintSchemeFor: string | null;
  dryDockComment: string | null;
  latestHullEvent: string | null;
  hullCleaned: string | null;
  propellerPolished: string | null;
  placeVendor: string | null;
  minMcrPercent: number | null;
  maxMcrPercent: number | null;
}

export interface VesselEvaluationDashboard {
  vessels: VesselEvaluationVessel[];
  totalVessels: number;
  offset: number;
  limit: number;
  totalPages: number;
  filterOptions: VesselEvaluationFilterOptions;
  refreshedAt: string | null;
}

export type VesselEvaluationFilterKey =
  | "imo"
  | "status"
  | "vesselType"
  | "buildYear"
  | "paintVendor"
  | "vesselName"
  | "contractType"
  | "design"
  | "engineType"
  | "scrubber";

export type VesselEvaluationFilters = Record<VesselEvaluationFilterKey, string[]>;
export type VesselEvaluationFilterOptions = Record<VesselEvaluationFilterKey, string[]>;

export const EMPTY_VESSEL_EVALUATION_FILTERS: VesselEvaluationFilters = {
  imo: [],
  status: [],
  vesselType: [],
  buildYear: [],
  paintVendor: [],
  vesselName: [],
  contractType: [],
  design: [],
  engineType: [],
  scrubber: [],
};

export type VesselEvaluationColumnFormat = "boolean" | "date" | "month" | "number" | "text";

export interface VesselEvaluationColumn {
  key: keyof VesselEvaluationVessel;
  label: string;
  format: VesselEvaluationColumnFormat;
}

export interface VesselEvaluationSort {
  key: keyof VesselEvaluationVessel;
  direction: "ascending" | "descending";
}

export interface VesselEvaluationDashboardRequest {
  filters: VesselEvaluationFilters;
  sort: VesselEvaluationSort;
  offset: number;
  limit: number;
}

export interface VesselEvaluationAccessToken {
  email?: string;
  sub?: string;
}
